export const COLOR = {
  BLUE: 'blue',
  GREEN: 'green',
  YELLOW: 'yellow',
} as const;

interface ColorProps {
  [key: string]: any;
}

export const COLOR_PROPS: ColorProps = {
  [COLOR.BLUE]: {
    label: 'blue100',
    bg: 'blue20',
    border: 'blue40',
  },
  [COLOR.GREEN]: {
    label: 'green100',
    bg: 'green20',
    border: 'green40',
  },
  [COLOR.YELLOW]: {
    label: 'yellow100',
    bg: 'yellow20',
    border: 'yellow40',
  },
};
